import { render, staticRenderFns } from "./GestioneAzienda.vue?vue&type=template&id=c84c9ac6&scoped=true&"
import script from "./GestioneAzienda.ts?vue&type=script&lang=ts&"
export * from "./GestioneAzienda.ts?vue&type=script&lang=ts&"
import style0 from "./GestioneAzienda.vue?vue&type=style&index=0&id=c84c9ac6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c84c9ac6",
  null
  
)

export default component.exports